export default "__VITE_ASSET__BhCBsHfO__"